/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import Hotkeys from 'react-hot-keys';
import {
  withSiteMap,
  processorSet,
  allSiteMap,
} from '@bingads-webui-react/with-site-map';
import { getShortcutList } from './shortcut-list';

const withHotKeysInternal = (Component, shortcutListType) => (props) => {
  const [key, setKey] = useState('');
  const [count, setCount] = useState(0);
  const listenToKeysList = getShortcutList(shortcutListType, props.hotKeySiteMap);
  const shorcutsLogger = props.instrumentation && props.instrumentation.newUIShortcuts ?
    props.instrumentation.newUIShortcuts.create().shortcutSet.create() : undefined;
  return (
    <React.Fragment>
      <Hotkeys
        keyName={listenToKeysList}
        onKeyUp={(keyName) => {
          setKey(keyName);
          setCount(count + 1);
          if (shorcutsLogger) {
            shorcutsLogger.trace({
            component: 'Shortcuts',
            keyName,
          });
          }
        }}
      >
        {listenToKeysList.indexOf(key) > -1 ?
          <Component {...props} count={count} hotKey={key} />
          : <Component {...props} />
        }
      </Hotkeys>
    </React.Fragment>
  );
};

export const withHotKeys = (Component, shortcutListType) =>
  withSiteMap(withHotKeysInternal(Component, shortcutListType), processorSet.basic, allSiteMap, null, 'hotKeySiteMap');
